import { Row } from '@shared/components/core/layouts/CommonLayoutStyles';
import { extractRoleProperties } from '@shared/hooks/helpers/OrganizationalHelpers';
import OrganizationMemberModel from '@shared/models/organizations/OrganizationMemberModel';
import { OrgDetailItemsWrapper, OrgDetailWrapper } from '../CommonOrgStyles';
import RoleIconList from '../role/RoleIconList';
import MemberDetailItem from './MemberDetailItem';

interface IMemberDetailStackProps {
    member: OrganizationMemberModel;
    hideWrapper?: boolean;
}

export default function MemberDetailStack({ member, hideWrapper }: Readonly<IMemberDetailStackProps>) {
    if (!member) return null;

    const content = (
        <OrgDetailItemsWrapper>
            <Row>
                {member.user?.firstName && member.user?.lastName ? (
                    <>
                        <MemberDetailItem icon="user" title={member.user?.firstName + ' ' + member.user?.lastName} />
                        <MemberDetailItem title={member.user?.email} />
                    </>
                ) : (
                    <MemberDetailItem icon="user" title={member.user?.email} />
                )}
            </Row>
            <RoleIconList role={extractRoleProperties(member)} />
        </OrgDetailItemsWrapper>
    );

    return hideWrapper ? content : <OrgDetailWrapper>{content}</OrgDetailWrapper>;
}
